import type { IconDefinition } from '../index.tsx';

export const iconCards: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCards',
  icon: [
    16,
    16,
    [],
    '',
    'M8.36798 0.957311C8.22373 0.427389 7.67911 0.112969 7.14806 0.253033L0.974474 1.88133C0.437469 2.02297 0.118745 2.57505 0.264616 3.11092L2.99789 13.1519C3.14214 13.6818 3.68677 13.9962 4.21781 13.8562L4.66754 13.7375L4.63376 13.8616L11.7819 15.747C12.313 15.887 12.8576 15.5726 13.0019 15.0427L15.7351 5.00173C15.881 4.46586 15.5623 3.91378 15.0253 3.77215L8.67854 2.09818L8.36798 0.957311ZM7.45576 13.0021L10.3914 12.2279C10.9284 12.0862 11.2471 11.5341 11.1013 10.9983L9.14888 3.82601L14.0724 5.1246L11.6284 14.1027L7.45576 13.0021Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
